import React from 'react';
import './SunDesigns.css';

// Statik dekoratif gökyüzü (yıldızlar + yay + güneş/ay). Dinamik değer taşımaz.
const SKY_HTML = `
<svg class="d3-sky" viewBox="0 0 1000 330" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
  <defs>
    <linearGradient id="d3arc" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="#ffce7a"/><stop offset=".5" stop-color="#b9a8ff"/><stop offset="1" stop-color="#8f9bff"/>
    </linearGradient>
    <radialGradient id="d3sunG" cx="50%" cy="50%" r="50%">
      <stop offset="0" stop-color="#fff4d6"/><stop offset=".4" stop-color="#ffcf80"/><stop offset="1" stop-color="rgba(255,180,90,0)"/>
    </radialGradient>
    <radialGradient id="d3moonG" cx="50%" cy="50%" r="50%">
      <stop offset="0" stop-color="#ffffff"/><stop offset=".5" stop-color="#cdd3ff"/><stop offset="1" stop-color="rgba(160,170,255,0)"/>
    </radialGradient>
  </defs>
  <g>
    <circle class="d3-star d3-tw" cx="140" cy="60" r="1.4"/><circle class="d3-star" cx="260" cy="40" r="1"/>
    <circle class="d3-star d3-tw2" cx="380" cy="90" r="1.6"/><circle class="d3-star" cx="520" cy="50" r="1.1"/>
    <circle class="d3-star d3-tw" cx="640" cy="80" r="1.3"/><circle class="d3-star" cx="760" cy="44" r="1"/>
    <circle class="d3-star d3-tw2" cx="860" cy="96" r="1.5"/><circle class="d3-star" cx="930" cy="58" r="1.1"/>
    <circle class="d3-star d3-tw" cx="60" cy="120" r="1.2"/><circle class="d3-star" cx="450" cy="150" r="1"/>
    <circle class="d3-star d3-tw2" cx="700" cy="140" r="1.2"/>
  </g>
  <path d="M120 300 C 300 70, 700 70, 880 300" fill="none" stroke="url(#d3arc)" stroke-width="1.6" stroke-dasharray="2 7" opacity=".55"/>
  <circle cx="112" cy="312" r="66" fill="url(#d3sunG)"/>
  <circle cx="112" cy="312" r="13" fill="#ffd98c"/>
  <circle cx="888" cy="312" r="52" fill="url(#d3moonG)"/>
  <circle cx="888" cy="312" r="10" fill="#e6eaff"/>
</svg>`;

// 03 · Yörünge — Gökyüzü · gündüz yayı
const D3Yorunge = ({ vm }) => (
  <div className="gsk">
    <div className="stage">
      <div className="d3">
        <div dangerouslySetInnerHTML={{ __html: SKY_HTML }} />
        <div className="d3-inner">
          <div className="d3-head">
            <span className="loc">{vm.locationDot}</span>
            <span className="date">{vm.dateShort}</span>
          </div>
          <div className="d3-body">
            <div className="d3-side d3-side--rise">
              <span className="d3-cap">↑ Doğuş</span>
              <span className="d3-time d3-time--rise">{vm.sunriseDst}</span>
              {vm.isDst && <span className="d3-norm">standart · {vm.sunriseNormal}</span>}
            </div>
            <div className="d3-mid">
              <div className="len">{vm.daylightDuration.long}</div>
              <div className="lab">gündüz süresi</div>
            </div>
            <div className="d3-side d3-side--set">
              <span className="d3-cap">Batış ↓</span>
              <span className="d3-time d3-time--set">{vm.sunsetDst}</span>
              {vm.isDst && <span className="d3-norm">standart · {vm.sunsetNormal}</span>}
            </div>
          </div>
          <p className="d3-note">{vm.dstNote}</p>
        </div>
      </div>
    </div>
  </div>
);

export default D3Yorunge;
